// Track which deprecation warnings have been shown this session
const shownWarnings = new Set();

/**
 * Show a deprecation warning once per browser session
 * @param {string} name - The name of the deprecated function/getter/mutation
 * @param {string} message - Optional additional message
 */
export function warnDeprecated(name, message = '') {
  if (process.env.VUE_APP_DEV_LOCAL!=='true'){
    return false
  }
  if (shownWarnings.has(name)) {
    return;
  }

  shownWarnings.add(name);

  const fullMessage = message
    ? `[DEPRECATED] ${name}: ${message}`
    : `[DEPRECATED] ${name} is deprecated and will be removed. Use direct API calls instead.`;

  console.warn(fullMessage, new Error('deprecated method called'));
}
